import React, { useContext, useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import bgImage from "assets/images/login-icon.jpg";
import { resetPassword } from "Apis/signIn";
import { LoginFormContext } from "context/LoginFormContext";
import { useNavigate } from "react-router-dom";
import { AuthRouteJson } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

const ResetPassword = () => {
  const { sideNav } = colors;
  const navigate = useNavigate();
  const { setNotification } = useContext(LoginFormContext);
  const [visiblePassword, setVisiblePassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });

  const handleSeePassword = (type) => {
    setVisiblePassword((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const initialValues = {
    new_password: "",
    confirm_password: "",
  };

  const validationSchema = Yup.object({
    new_password: Yup.string()
      .required("New Password is required !")
      .min(6, "Password length at least 6.")
      .matches(/[0-9]/, "Password requires a number")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter")
      .matches(/[^\w]/, "Password requires a special character"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Confirm password must be the same as the password")
      .required("Confirm Password is required!"),
  });

  const handleSubmit = async (values) => {
    let response = await resetPassword(values);
    if (response?.status === 200) {
      localStorage.removeItem("resetToken");
      navigate(AuthRouteJson.signin);
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  const passwordRequirements = [
    "Min six characters (ન્યૂનતમ છ અક્ષરો)",
    "At least one digit (ઓછામાં ઓછું એક અંક હોવો જોઈએ)",
    "At least one lowercase letter (એક નાનું (a-z) અક્ષર જરૂર હોવું જોઈએ)",
    "At least one uppercase letter (એક મોટાં (A-Z) અક્ષર હોવું જોઈએ)",
    "At least one special character (ઓછામાં ઓછું એક વિશેષ ચિહ્ન હોવું જોઈએ)",
  ];
  return (
    // <CoverLayout>
    <MDBox
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          width: "80%",
          maxWidth: "1030px",
          padding: "20px",
          gap: "25px",
          background: `${sideNav.backGround}`,
          borderRadius: "8px",
          margin: "0 auto",
          justifyContent: "center",
          "@media (max-width:1020px)": {
            flexDirection: "column",
          },
          "@media (max-width:767px)": {
            width: "90%",
          },
        }}
      >
        <MDBox
          sx={{
            width: "auto",
            height: "460px",
            "@media (max-width: 1020px)": { width: "auto", height: "170px" },
            // "@media (max-width:767px)": { width: "auto", height: "200px" },
          }}
        >
          <img
            src={bgImage}
            width={100}
            height={100}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </MDBox>
        <Card
          sx={{
            gap: "10px",
            width: "52%",
            background: "transparent",
            boxShadow: "none",
            "@media (max-width:1020px)": {
              width: "100%",
            },
          }}
        >
          <MDBox
            // variant="gradient"
            // bgColor="info"
            // borderRadius="lg"
            // coloredShadow="success"
            // mx={2}
            // mt={-3}
            // py={2}
            // mb={1}
            // pt={4}
            // p={{ xl: 2.25 }}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="#334155" fontSize="1.5rem">
              Reset Password
            </MDTypography>
          </MDBox>
          <MDBox p={{ xl: 2.25 }}>
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDBox mb={2}>
                <MDInput
                  variant="standard"
                  type={!visiblePassword?.newPassword ? "password" : "text"}
                  label="New Password"
                  name="new_password"
                  value={formik.values.new_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleSeePassword("newPassword")}
                          edge="end"
                          size="large"
                        >
                          {!visiblePassword?.newPassword ? (
                            <VisibilityOff sx={{ width: "25px", height: "25px" }} />
                          ) : (
                            <Visibility sx={{ width: "25px", height: "25px" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.new_password && formik.errors.new_password && (
                  <MDBox
                    component="p"
                    sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
                  >
                    {formik.errors.new_password}
                  </MDBox>
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  variant="standard"
                  type={!visiblePassword?.confirmPassword ? "password" : "text"}
                  label="Confirm Password"
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleSeePassword("confirmPassword")}
                          edge="end"
                          size="large"
                        >
                          {!visiblePassword?.confirmPassword ? (
                            <VisibilityOff sx={{ width: "25px", height: "25px" }} />
                          ) : (
                            <Visibility sx={{ width: "25px", height: "25px" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.confirm_password && formik.errors.confirm_password && (
                  <MDBox
                    component="p"
                    sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
                  >
                    {formik.errors.confirm_password}
                  </MDBox>
                )}
              </MDBox>
              <MDBox mt={6} mb={1}>
                <MDBox fontSize="20px" fontWeight="600" color={sideNav.textColor}>
                  Password requirements (પાસવર્ડના નિયમો)
                </MDBox>
              </MDBox>
              <MDBox mb={1}>
                <MDTypography variant="body2" color="text">
                  Please follow this guide for a strong password
                </MDTypography>
              </MDBox>
              <MDBox mt={1}>
                {passwordRequirements.map((requirement, index) => (
                  <MDBox key={index} sx={{ fontSize: "13px", color: "gray" }}>
                    - {requirement}
                  </MDBox>
                ))}
              </MDBox>
              <MDBox mt={3} mb={1}>
                <SubmitButton type="submit" btnText={"Change password"} width="100%" />
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
    // </CoverLayout>
  );
};

export default ResetPassword;
